import React from 'react';
import { connect } from 'react-redux';
import { ApplActionsButton } from '../../common/ApplicationComponents';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { PropertyStatusTypeOptions } from '../../common/ApplicationConstants';
import { AppraiseStageType } from '../common/Constants';
import {
    onCellDblClickAppraisalReceive,
    onCellDblClickAppraisalReview,
    onCellDblClickConvertToLoan,
} from '../../common/ApplicationFunctions';

const OrderedPortfolioTable = ({ data, stage = AppraiseStageType.Order }) => {
    const styles = {
        due: { whiteSpace: 'nowrap' },
        overdue: { color: 'red', whiteSpace: 'nowrap' },
    };

    const actionCellRender = (e) => {
        return (
            <ApplActionsButton
                data={e.data}
                parentElementId='orderedPortfolio'
                isPropertyLevel={true}
            />
        );
    };

    const onAddressCellRender = (e) => {
        if (e.data.address.street2) {
            return e.data.address.street1 + ', ' + e.data.address.street2;
        } else {
            return e.data.address.street1;
        }
    };

    const onStatusIdRender = (e) => {
        const statusType = PropertyStatusTypeOptions.find((a) => a.id === e.data.propertyStatusId);
        return statusType?.shortName;
    };

    const onExpectedCellRender = (e) => {
        if (!e.data.expectedDate) {
            return null;
        }
        const expectedDate = new Date(e.data.expectedDate).toLocaleDateString('en-us');
        return (
            <>
                <span>{expectedDate}</span>
                <span>
                    {e.data.daysOverdue > 0 && (
                        <div>
                            <span style={e.data.daysOverdue >= 3 ? styles.overdue : styles.due}>({e.data.daysOverdue} ago)</span>
                        </div>
                    )}
                    {e.data.daysOverdue < 0 && (
                        <div>
                            <span style={styles.due}>(in {e.data.daysOverdue * -1} days)</span>
                        </div>
                    )}
                </span>
            </>
        );
    };

    const onCellPrepared = (e) => {
        if (e.rowType !== 'data') {
            return;
        }

        if (!e.data.disabled) {
            e.cellElement.id = null;
        } else {
            e.cellElement.className = 'dx_portfolio_inactive';
        }
    };

    if (!data || data.length === 0) {
        return '';
    }

    return (
        <DataGrid
            dataSource={data}
            showBorders={true}
            showRowLines={false}
            rowAlternationEnabled={true}
            remoteOperations={false}
            allowColumnReordering={false}
            allowColumnResizing={true}
            width={'95%'}
            cellHintEnabled={true}
            onCellPrepared={onCellPrepared}
            onCellDblClick={(() => {
                switch (stage) {
                    case AppraiseStageType.Receive:
                        return onCellDblClickAppraisalReview;
                    case AppraiseStageType.Order:
                        return onCellDblClickAppraisalReceive;
                    case AppraiseStageType.Review:
                        return onCellDblClickConvertToLoan;
                    default:
                        return onCellDblClickAppraisalReceive;
                }
            })()}
        >
            <Column
                dataField='propertyStatusId'
                caption='Status'
                width={120}
                cellRender={onStatusIdRender}
                alignment={'left'}
            />
            <Column
                dataField='address.street1'
                caption='Address'
                cellRender={onAddressCellRender}
            />
            <Column
                dataField='address.city'
                caption='City'
                width={150}
            />
            <Column
                dataField='address.state'
                caption='State'
                width={70}
            />
            <Column
                dataField='address.zipCode'
                caption='Zip'
                width={70}
            />
            <Column
                dataField='bfiNumber'
                caption='BFI #'
                dataType='string'
                width={100}
            />
            <Column
                dataField='orderedDate'
                caption='Ordered'
                dataType='date'
                width={100}
            />
            <Column
                dataField='expectedDate'
                caption='Expected'
                width={100}
                cellRender={onExpectedCellRender}
                visible={stage === AppraiseStageType.Order}
            />
            <Column
                dataField='receivedDate'
                caption='Received'
                dataType='date'
                width={100}
                visible={stage >= AppraiseStageType.Receive}
            />
            <Column
                dataField='cost'
                caption='Cost'
                width={90}
                dataType='number'
                format='currency'
                alignment='left'
            />
            <Column
                dataField='appraiserCompany'
                caption='Appraiser'
                dataType='string'
                width={120}
            />
            <Column
                dataField='notes'
                caption='Notes'
                dataType='string'
                width={120}
            />
            <Column
                alignment='center'
                cellRender={actionCellRender}
                width={50}
                allowReordering={false}
                allowSorting={false}
                allowResizing={false}
                type='actions'
                fixed={true}
                fixedPosition={'right'}
            />
        </DataGrid>
    );
};

export default OrderedPortfolioTable;
